<template>
  <b-card-code>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-start">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">البحث</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="قم بالبحث هنا"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table condensed"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <!-- Slot: Table Row -->
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <!-- size -->
            <router-link
              :to="{
                name: 'ViewRequest',
                params: {
                  id: props.row.id,
                },
              }"
            >
              <b-avatar size="32" variant="light-primary">
                <feather-icon icon="EyeIcon" size="18" />
              </b-avatar>
            </router-link>
            <router-link @click.native="confirmText" to="">
              <b-avatar class="mr-1 ml-1" size="32" variant="light-danger">
                <feather-icon icon="Trash2Icon" size="18" />
              </b-avatar>
            </router-link>
          </span>
        </span>
        <span v-if="props.column.field === 'status'">
          <span
            v-if="props.row.status == 'قيد المراجعة'"
            class="badge badge-warning"
          >
            {{ props.row.status }}</span
          >
          <span
            v-if="props.row.status == 'تمت الموافقة'"
            class="badge badge-success"
          >
            {{ props.row.status }}</span
          >
          <span
            v-if="props.row.status == 'تم الرفض '"
            class="badge badge-danger"
          >
            {{ props.row.status }}</span
          >
        </span>
        <span v-else-if="props.column.field === 'applicants_name'">
          <span>{{ props.row.applicants_name }} </span>
          <br />
          <span class="text-primary">{{ props.row.applicants_title }}</span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              <!-- {{ $t("g.pagelength") }} -->
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap">
              <!-- {{ $t("g.of") }} {{ props.total }}
              {{ $t("g.pageText2") }} -->
              {{ props.total }}
            </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BButtonGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";

export default {
  components: {
    BCardCode,
    VueGoodTable,
    Ripple,
    BAvatar,
    BButtonGroup,
    BButton,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: " التاجر",
          field: "merchant_name",
        },
        {
          label: " مقدم الطلب",
          field: "applicants_name",
        },

        {
          label: "نوع الطلب",
          field: "request_type",
        },
        {
          label: "تاريخ التقديم ",
          field: "start_date",
        },
        {
          label: "حالة الطلب",
          field: "status",
        },

        {
          label: "الإجراء",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  methods: {
    confirmText() {
      console.log("Clicked");
      this.$swal({
        title: "هل انت متأكد ؟",
        text: "لن تتمكن من التراجع عن هذا!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم ، احذفها!",
        cancelButtonText: "إلغاء",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "تم الحذف!",
            text: "تم حذف الملف",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
  created() {
    axios
      .get("https://mocki.io/v1/73ca4d1f-bfb8-463e-973c-f850ee83cac0")
      .then((res) => {
        console.log(res);
        this.rows = res.data.data;
      });
  },
};
</script>


<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>